/*
* @TagTable.vue
* @Description 基站管理组件
* @Author jsh
* @Date 2021/6/28
*/
<template>
    <div class="table-item-box _padding-l-none" style="padding: 10px;">
        <section style="height: 100%;">
            <!-- 表格 -->
            <el-table :data="bsGroups"
                      @sort-change="changeSort"
                      ref="multipleTable"
                      stripe
                      style="width: 100%;margin-bottom: 10px;height: calc(100% - 44px);"
                      :class="{'table': true, 'no-pagination': false}">
                <el-table-column type="selection" :selectable="checkSelectable"/>
                <el-table-column label="基站组id" :sortable="filters.sortable" prop="group_id" :sort-orders="filters.sortOrders">
                    <template v-slot="scope">
                        {{scope.row.groupId}}
                    </template>
                </el-table-column>
                <el-table-column label="基站组名" :sortable="filters.sortable" prop="group_name" :sort-orders="filters.sortOrders">
                    <template v-slot="scope">
                        {{scope.row.groupName}}
                    </template>
                </el-table-column>
                <el-table-column label="类型">
                    <template v-slot="scope">
                        <span style="white-space: nowrap;" :title="groupTypes[scope.row.type]">{{groupTypes[scope.row.type]}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="有效距离">
                    <template v-slot="scope">
                        <span style="white-space: nowrap;" :title="scope.row.distance">{{scope.row.type==0?(scope.row.distance+' 米'):'不限'}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="关联地图" min-width="100px">
                    <template v-slot="scope">
                        <span style="white-space: nowrap;" :title="scope.row.mapNames">{{scope.row.mapNames}}</span>
                    </template>
                </el-table-column>
            </el-table>

            <!--分页工具条-->
            <Pagination
                :currentPage="pagination.currentPage"
                :total="pagination.total"
                :pageSize="pagination.limit"
                @handleSizeChangeSub="handleSizeChangeSub"
                @handleCurrentChangeSub="handleCurrentChangeSub"
            />

        </section>
    </div>

</template>

<script>
    // 基站组件
    import ApiOam from '@/request/api-oam'
    // 分页组件
    import Pagination from '@/components/Pagination.vue'

    export default {
        name: "UwbBSGroupTable",
        /**
         * @Des 组件引用
         * @Auth jsh
         * @Date 09:41 2021/6/28
         */
        components: {
            // 分页工具
            Pagination
        },
        /**
         * @Des 数据定义
         * @Auth jsh
         * @Date 09:41 2021/6/28
         */
        data() {
            return {
                /**
                 * @Des 查询条件属性
                 * @Auth jsh
                 * @Date 09:41 2021/6/28
                 */
                filters: {
                    orderBy: {
                        "project_id": "asc"
                    },
                    sortOrders: [
                        "ascending",
                        "descending"
                    ],
                    sortable: 'custom',
                },
                bsGroups:[],
                projectInfos: {},
                areas: {},
                maps: {},
                groupTypes: ['零维','一维','二维','三维'],
                /**
                 * @Des 分页数据
                 * @Auth
                 * @Date 2021/6/4
                 */
                pagination:{
                    total: 0,
                    startNum: 0,
                    limit: 50,
                    currentPage: 1
                },
            }
        },
        computed: {
        },
        created(){
        },
        mounted(){
          this.searchOrg();
        },
        /**
         * @Des 方法定义
         * @Auth jsh
         * @Date 09:42 2021/6/28
         */
        methods: {
            /**
             * 查询组织结构
             * */
            searchOrg() {
                this.$request.postJsonRequest(ApiOam.Find_Org_Uri, {
                    projectId: this.$store.state.currentProjectId
                }).then(result => {
                    // console.log(result)
                    this.areas = Object.assign({}, {});
                    this.maps = Object.assign({}, {});
                    if(result.code == 0){
                        result.data.forEach((row, index) => {
                          if(row.level == 1){
                            this.projectInfos[row.id] = row.node;
                          }
                        })
                        result.data.forEach((row, index) => {
                            if(this.projectInfos.hasOwnProperty(row.parentId)){
                                // 上级是项目
                                if(this.projectInfos[row.parentId].hasArea == 1){
                                    // 如果有区域
                                    this.areas[row.id] = row.node;
                                }else{
                                    this.maps[row.id] = row.node;
                                }
                            }
                        });
                        result.data.forEach((row, index) => {
                            if(this.areas.hasOwnProperty(row.parentId)){
                                this.maps[row.id] = row.node;
                            }
                        })
                    }
                    // console.log(this.areas)
                    // console.log(this.maps)
                    this.searchBsGroup();
                }).catch(error => {
                    console.error('查询组织结构异常', ApiOam.Find_Org_Uri, error);
                })
            },

            /**
             * @Des 查询基站组
             * @Auth jsh
             * @Date 09:42 2021/6/28
             */
            searchBsGroup() {
                this.$request.postJsonRequest(ApiOam.Search_Uwb_Bs_Group_Uri, {
                    projectId: this.$store.state.currentProjectId,
                    orderBy: this.filters.orderBy,
                    total: this.pagination.total,
                    startNum: this.pagination.startNum,
                    limit: this.pagination.limit,
                }).then(result => {
                    // console.log(result)
                    this.bsGroups = [];
                    this.pagination.total = result.total;
                    if(result.total > 0){
                        result.rows.forEach((row, index) => {
                            // 区域名
                            row.areaName = "";
                            if(row.areaId != undefined && row.areaId != ''){
                                if(this.areas.hasOwnProperty(row.areaId)){
                                    row.areaName = this.areas[row.areaId].areaName;
                                }
                            }
                            // console.log(row.areaId, row.areaName);

                            // 地图
                            row.mapIdArray = [];
                            row.mapNameArray = [];
                            if(row.mapId != undefined && row.mapId != null){
                                if(this.maps.hasOwnProperty(row.mapId)){
                                    row.mapIdArray.push(row.mapId);
                                    row.mapNameArray.push(this.maps[row.mapId].mapName);
                                }
                            }
                            row.mapIds = row.mapIdArray.join(",");
                            row.mapNames = row.mapNameArray.join(",");
                            // console.log(row.mapIds, row.mapNames);

                            this.bsGroups.push(row);
                        });
                    }
                    // console.log(this.bsGroups)
                }).catch(error => {
                    console.error('查询基站组异常', ApiOam.Search_Uwb_Bs_Group_Uri, error);
                })
            },

            /**
             * 是否选择
             * */
            checkSelectable(row){
                return true;
            },
            /**
             * 重新搜索
             * */
            researchBsGroup(){
                this.pagination.total = 0;
                this.pagination.startNum = 0;
                this.pagination.currentPage = 1;
                this.searchBsGroup();
            },
            /**
             * 改变排序
             * */
            changeSort(data){
                let prop = data.prop;
                let order = data.order;
                if(order == null){
                    order = this.filters.orderBy[prop];
                }else{
                    order = order.replace("ending", "");
                }
                if(order == null){
                    this.filters.orderBy["project_id"] = "asc";
                }else{
                    this.filters.orderBy = {};
                    this.filters.orderBy[prop] = order;
                }
                this.researchBsGroup();
            },

            /**
             * @Des 当前页数据改变
             * @Auth
             * @Date 2021/6/4
             */
            handleCurrentChangeSub(val){
                this.pagination.currentPage = val;
                this.pagination.startNum = this.pagination.limit * (val-1);
                this.searchBsGroup()

            },
            /**
             * @Des 页长度改变
             * @Auth
             * @Date 2021/6/4
             */
            handleSizeChangeSub(val){
                this.pagination.limit = val;
                this.pagination.currentPage = 1;
                this.pagination.startNum = 0;
                this.searchBsGroup()
            },


        },


    }
</script>

/* CSS */
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components_pages/Device/UwbBSGroupTable.vue